import { render, staticRenderFns } from "./AddFlagHistory.vue?vue&type=template&id=6c66b9b1&scoped=true&"
import script from "./AddFlagHistory.vue?vue&type=script&lang=js&"
export * from "./AddFlagHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c66b9b1",
  null
  
)

export default component.exports